var thirdEmbeds = [
  {
    name: "facebook",
    regex:
      /(?:https?:\/\/)?(?:www\.)?(mbasic.facebook|(m\.)?facebook|fb)(\.watch|\.com.*)?(\/(video(s)?|watch|story))?(\.php?|\/).+$/,
    html: function (url, matches) {
      return $("<div>", {
        "data-href": url,
        "data-width": "auto",
        "data-lazy": true,
        class: url.match(/(?:fb\.watch.*)?(video(s)?|watch|story)(\.php?|\/)/)
          ? "fb-video"
          : "fb-post",
      }).get(0);
    },
  },
  {
    name: "twitter",
    regex: /(?:https?:\/\/)?((?:www\.)?(?:twitter|x)\.com.*)/,
    html: function (url, matches) {
      // 本地組官方 blockquote + widgets.js（同 tiktok 模式），不再打
      // publish.twitter.com/oembed jsonp：
      //  1. 既有內容存的 /i/web/status/<id> 形式該 API 回 404（HTML 錯誤頁），
      //     jsonp script 因 MIME 不符被瀏覽器 ORB 擋下 → 嵌入空白
      //  2. widgets.js 載入後自動掃描 .twitter-tweet 渲染，輸出與 oembed
      //     回傳的 html 相同，且不依賴 oembed API 的 URL 形式白名單
      let idMatch = url.match(/status(?:es)?\/(\d+)/);

      if (idMatch) {
        return $("<div>", {
          html: $("<blockquote>", {
            class: "twitter-tweet",
            align: "center",
            html: $("<a>", {
              href: `https://twitter.com/i/status/${idMatch[1]}`,
            }),
          }),
        }).get(0);
      }
      return;
    },
  },
  {
    name: "googleMap",
    regex: /(?:https?:\/\/)?(?:www\.)?google\.com(.*)?\/maps.*/,
    html: function (url, matches) {
      // google map API key
      const key = "AIzaSyDss-vrZJt61Ffr_OCugE26OHao7R6sSao";

      const buildIframe = function (mapUrl) {
        return $("<div>", {
          class: "no-fv",
          html: $("<iframe>", {
            src: mapUrl,
            width: "100%",
            height: 500,
            frameborder: 0,
            loading: "lazy",
            scrolling: "no",
            allowfullscreen: false,
          }),
        }).get(0);
      };

      // 1) embed URL（iframe 貼上 / Lexical 語意匯出 / 舊 CKEditor 內容）
      //    → 直接 iframe；URL 內的 key 一律換成前台 key，DB 不依賴任何歷史 key
      if (/google\.com(\.[a-zA-Z]+)?\/maps\/embed/.test(url)) {
        return buildIframe(url.replace(/([?&])key=[^&]*/, "$1key=" + key));
      }

      // 2) 含 @座標 的 /maps/ URL（原有邏輯）
      // latitude, longitude, zoom
      matches = url.match(/@(.*?),(.*?),([\d\.,-]+)z/);

      if (matches) {
        let placeMatches = url.match(/place\/(.*?)\//),
          searchMatches = url.match(/search\/(.*?)\//);

        let mapUrl;
        if (!searchMatches) {
          mapUrl = `${document.location.protocol}//www.google.com/maps/embed/v1/place?center=${matches[1]},${matches[2]}&zoom=${matches[3]}&key=${key}`;
          mapUrl += placeMatches
            ? `&q=${placeMatches[1]}`
            : `&q=${matches[1]},${matches[2]}`;
        } else {
          mapUrl = `${document.location.protocol}//www.google.com/maps/embed/v1/search?key=${key}&center=${matches[1]},${matches[2]}&zoom=${matches[3]}&q=${searchMatches[1]}`;
        }

        return buildIframe(mapUrl);
      }

      // 3) 無 @座標 的 place URL（Lexical 語意匯出的地名形態）→ 以 q= 渲染
      let placeOnly = url.match(/\/maps\/place\/([^\/@?]+)/);
      if (placeOnly) {
        return buildIframe(
          `${document.location.protocol}//www.google.com/maps/embed/v1/place?key=${key}&q=${placeOnly[1]}`
        );
      }

      return;
    },
  },
  {
    name: "youtube",
    regex:
      /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)/,
    html: function (url, matches) {
      if (matches && matches[1].length > 0) {
        return $("<div>", {
          style: "padding-bottom:56.25%; position:relative; height:0;",
          html: $("<div>", {
            style: "position:absolute; top:0; left:0; width:100%; height:100%;",
            class: "ytplayer no-fv",
            id: matches[1],
          }),
        }).get(0);
      }
      return;
    },
  },
  {
    name: "instagram",
    regex: /(?:https?:\/\/www\.)?instagram\.com\S*?\/(?:p|tv)\/([\w-]{11})\/?/,
    html: function (url, matches) {
      if (matches && matches[1].length > 0) {
        let name = this.name;
        let idx = thirdEmbedScript.findIndex(function (object) {
          return object.name === name;
        });

        return $("<div>", {
          html: $("<blockquote>", {
            class: "instagram-media mx-auto",
            "instgrm-captioned": "",
            "instgrm-permalink": matches[0],
            "instgrm-version": 14,
            style:
              "background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);",
            html: thirdEmbedScript[idx].getHtml(matches[1]),
          }),
        }).get(0);
      }

      return;
    },
  },
  {
    name: "dcard",
    regex:
      /(?:https?:\/\/(?:www|embed)\.)?dcard\.tw\S*?\/(?:p|posts)\/(\w*)\/?/,
    html: function (url, matches) {
      if (matches && matches[1].length > 0) {
        return $("<div>", {
          html: $("<iframe>", {
            src: `https://embed.dcard.tw/v1/posts/${matches[1]}/?showMedia=1`,
            frameborder: 0,
            loading: "lazy",
            scrolling: "no",
            allowfullscreen: false,
            class: "dcard-media",
          }),
        }).get(0);
      }
      return;
    },
  },
  {
    name: "tiktok",
    regex:
      /(?:https?:.*)\/\/(?:www\.tiktok\.com.*\/|trending.?shareId=)([\d]*)/,
    html: function (url, matches) {
      if (matches && matches[1].length > 0) {
        return $("<div>", {
          html: $("<blockquote>", {
            class: "tiktok-embed",
            cite: url,
            "data-video-id": matches[1],
            style: "max-width:605px; min-width:325px;",
            html: "<section></section>",
          }),
        }).get(0);
      }
      return;
    },
  },
  {
    name: "googleDrive",
    regex:
      /(?:https?:\/\/)?drive\.google\.com\/file\/d\/(.*?)\/.*?\?usp=(?:sharing|drive_link)/,
    html: function (url, matches) {
      return $("<div>", {
        html: `<video preload="auto" crossorigin="anonymous" autoplay muted loop style="width:100%">
                <source src="https://drive.lienuc.com/uc?id=${matches[1]}" type='video/mp4'>
                </video>`,
      }).get(0);
    },
  },
  {
    name: "vimeo",
    regex:
      /(?:https?:\/\/)?(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|)(\d+)(?:|\/\?)/,
    html: function (url, matches) {
      return $("<div>", {
        class: "no-fv",
        style: "padding-bottom:56.25%; position:relative; height:0;",
        html: $("<iframe>", {
          title: "vimeo-player",
          src: `https://player.vimeo.com/video/${matches[1]}`,
          allowfullscreen: true,
          frameborder: 0,
          style: "position:absolute; top:0; left:0; width:100%; height:100%;",
        }),
      }).get(0);
    },
  },
];
var thirdEmbedScript = [
  {
    name: "facebook",
    import: false,
    url: "https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v13.0",
    defer: true,
    async: true,
    anotherFileLoaded: function () {
      this.import = !isFileLoaded(
        "script[src*='https://connect.facebook.net/zh_TW/sdk/xfbml.customerchat.js']"
      );
    },
  },
  {
    name: "tiktok",
    import: false,
    url: "https://www.tiktok.com/embed.js",
    defer: false,
    async: true,
  },
  {
    // widgets.js 載入後會自動掃描頁面上的 blockquote.twitter-tweet 渲染
    name: "twitter",
    import: false,
    url: "https://platform.twitter.com/widgets.js",
    defer: false,
    async: true,
  },
  {
    name: "youtube",
    import: false,
    url: "https://www.youtube.com/player_api",
    defer: false,
    async: false,
    afterLoadFunction: function () {
      window.onYouTubePlayerAPIReady = function () {
        onYouTubeIframeAPIReady();
      };
    },
  },
  {
    name: "instagram",
    import: false,
    url: "https://www.instagram.com/embed.js",
    defer: false,
    async: true,
    afterLoadFunction: function () {
      window.__igEmbedLoaded = function (loadedItem) {
        window.instgrm.Embeds.process();
      };
    },
    getHtml: function (igPostNumber) {
      return `<div style="padding:16px;">
        <div style="padding:16px;">
        <a href="https://www.instagram.com/p/${igPostNumber}/?utm_source=ig_embed&amp;utm_campaign=loading" 
        style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank">
        <div style="display: flex; flex-direction: row; align-items: center;">
        <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div>
        <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;">
        <div style="background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div>
        <div style="background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div>
        <div style="padding: 19% 0;"></div>
        <div style="display:block; height:50px; margin:0 auto 12px; width:50px;">
        <svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-511.000000, -20.000000)" fill="#000000"><g>
        <path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div>
        <div style="padding-top: 8px;">
        <div style="color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">在 Instagram 查看這則貼文</div></div>
        <div style="padding: 12.5% 0;"></div>
        <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div>
        <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div>
        <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div>
        <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div>
        <div style="margin-left: 8px;"><div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div>
        <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div>
        <div style="margin-left: auto;">
        <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div>
        <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div>
        <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div>
        <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;">
        <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div>
        <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a></div>`;
    },
  },
];

$(function () {
  // Lexical TwitchNode 匯出的 iframe parent 為「匯出當下」的網域，
  // Twitch 要求 parent 必須是實際展示頁網域，這裡統一改寫為當前網域
  document
    .querySelectorAll('iframe[src*="player.twitch.tv"]')
    .forEach((iframe) => {
      let src = new URL(iframe.getAttribute("src"), document.location.href);
      if (src.searchParams.get("parent") !== document.location.hostname) {
        src.searchParams.set("parent", document.location.hostname);
        iframe.setAttribute("src", src.toString());
      }
    });

  document.querySelectorAll("oembed[url]").forEach((element) => {
    // Create the div or iframe element to discover the media.
    let anchor = renderHtml(element.getAttribute("url"));

    if (!anchor) {
      return;
    }

    element.append(anchor);
  });

  window.onYouTubePlayerAPIReady = function () {
    onYouTubeIframeAPIReady();
  };

  window.__igEmbedLoaded = function (loadedItem) {
    window.instgrm.Embeds.process();
  };

  // 檢查是否使用第三方平台，並引用該平台的串流API
  $.each(thirdEmbedScript, function (key, value) {
    if (value.anotherFileLoaded) {
      value.anotherFileLoaded();
    }

    if (value.afterLoadFunction) {
      value.afterLoadFunction();
    }

    if (value.import) {
      let params = {
        tag: "script",
        target: `[src*="${value.url}"]`,
        attr: {
          src: value.url,
          type: "text/javascript",
          defer: value.defer,
          async: value.async,
        },
      };
      importFile(params);
    }
  });
});

function convertToHtml(content) {
  if (!content) return;

  let $content = $(content);
  $content.find("oembed[url]").each(function (idx, element) {
    var html = renderHtml(element.getAttribute("url"));

    if (!html) {
      return;
    }

    element.closest("figure").appendChild(html);
    element.remove();
  });

  return $("<div>").append($content).html();
}

function renderHtml(url) {
  for (let i = 0; i < thirdEmbeds.length; i++) {
    let element = thirdEmbeds[i],
      regexes = [].concat(element.regex);

    for (let k = 0; k < regexes.length; k++) {
      let match = url.match(regexes[k]);

      if (match) {
        let idx = thirdEmbedScript.findIndex(function (object) {
          return object.name === element.name;
        });

        if (thirdEmbedScript[idx]) {
          thirdEmbedScript[idx].import = true;
        }
        return element.html(url, match);
      }
    }
  }

  return false;
}

function importFile(fileParams) {
  var isLoaded = isFileLoaded(`${fileParams.tag}${fileParams.target}`);

  if (!isLoaded) {
    var tag = document.createElement(fileParams.tag);
    $.each(fileParams.attr, function (key, value) {
      tag[key] = value;
    });
    var file = document.getElementsByTagName(fileParams.tag)[0];
    file.parentNode.insertBefore(tag, file);
  }
}

function isFileLoaded(element) {
  var $file = $(element);
  if ($file.length > 0) {
    return true;
  }
  return false;
}

function onYouTubeIframeAPIReady() {
  document.querySelectorAll("div.ytplayer").forEach((element) => {
    newYoutubePlayer($(element).attr("id"));
  });
}

var player = {},
  locationUrl = "{{url()}}";
function newYoutubePlayer(id) {
  if (!id) {
    return;
  }

  var playerParams = {
    videoId: id,
    host: "https://www.youtube-nocookie.com",
    playerVars: {
      enablejsapi: 1,
      showsearch: 0,
      iv_load_policy: 3,
      origin: locationUrl,
      vq: "hd1080",
    },
    events: {
      onReady: function (e) {
        player[id].setPlaybackQuality("hd1080");
      },
    },
  };

  player[id] = new YT.Player(id, playerParams);
}
